import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PlanPassedVerification
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/AllocationAnalysisActions/PlanPassedVerificationButton';
import AnalysisActionRequiredButton
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/AllocationAnalysisActions/AnalysisActionRequiredButton';
import RunAnalysisButton
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/AllocationAnalysisActions/RunAnalysisButton';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  drawerPaper: {
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md,
  },
  actionButton: {
    transition: 'all 0.3s ease',
  },
  actionsPaper: {
    borderRadius: theme.spacing(6),
  },
});

const ChartActions = ({
  className,
  classes,
}) => {
  const [isAnalysisRunning, setAnalysisRunning] = useState(false);
  const { pageContentResource, setPageContentCollection } = usePageContentContext();
  const { tabResources } = useTabContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const saveTabsAsNeeded = async () => {
    for (const tab of tabResources) {
      // if (tab.type() === 'FacetPlanTaxStrategy') {
      //   // We want to avoid deadlocks, so we'll do it sequentially
      //   // eslint-disable-next-line no-await-in-loop
      //   await tab.submit();
      //   continue;
      // }

      if (tab.type() !== 'FacetPlanAccountActionAllocationDetailBulkEditing') {
        continue;
      }

      for (const tableSectionResource of tab.attr('tableSections').resources().list()) {
        // We want to avoid deadlocks, so we'll do it sequentially
        // eslint-disable-next-line no-await-in-loop
        await tableSectionResource.submit();
      }
    }
  };


  const runAnalysisOnClick = async () => {
    setAnalysisRunning(true);
    try {
      await saveTabsAsNeeded();
      await pageContentResource?.relationship(fr.relationships.runAnalysis.name)?.link('related').get().then((resp) => {
        setPageContentCollection(resp);
      });
    } catch (err) {
      if (err.errors) {
        displayErrorMessage(err, err.errors);
      } else {
        displayErrorMessage(err, 'Error: failed to save account allocations');
      }
    } finally {
      setAnalysisRunning(false);
    }
  };

  const hasActionButton = pageContentResource?.attr('hasActionRequired') === 'true' || pageContentResource?.attr('hasReviewableWarnings') === 'true' || pageContentResource?.attr('hasAlerts') === 'true';
  const planPassedVerification = pageContentResource?.attr('planPassedVerification') === 'true';

  return (
    <Box className={classNames(classes.root, className)}>
      <Paper
        className={classes.actionsPaper}
        elevation={3}
      >
        { !planPassedVerification ? (
          <RunAnalysisButton
            className={classes.actionButton}
            onClick={runAnalysisOnClick}
            hasActionButton={hasActionButton}
            isLoading={isAnalysisRunning}
          />
        ) : (
          <PlanPassedVerification
            className={classes.actionButton}
            onClick={null} // <---- TODO: Plan Passed Verification onClick handler
            hasActionButton={hasActionButton}
          />
        )}
        <AnalysisActionRequiredButton
          className={classes.actionButton}
          hasActionRequired={pageContentResource?.attr('hasActionRequired') === 'true'}
          hasReviewableWarnings={pageContentResource?.attr('hasReviewableWarnings') === 'true'}
          hasAlerts={pageContentResource?.attr('hasAlerts') === 'true'}
        />
      </Paper>
    </Box>
  );
};

ChartActions.defaultProps = {
  className: '',
};

ChartActions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChartActions);
